import React, { FC } from 'react';
import { useMutation } from '@apollo/react-hooks';

import {
	AlternateId,
	AlternateIdInput,
	AlternateIdNamespaces,
	CreateOrUpdateAlternateIdResult,
	CreateOrUpdateAlternateIdVariables,
	DeleteAlternateIdResult,
	DeleteAlternateIdVariables
} from '../../utils/types';
import AlternateIds from './AlternateIds';
import { createAlternateId, deleteAlternateId } from './apiMutations';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useAlertContext } from '../../context/alertContext';
dayjs.extend(duration);

const NON_UNIQUE = [
	AlternateIdNamespaces.PROTECTED_AIRING,
	AlternateIdNamespaces.MERLIN_LISTING_ID,
	AlternateIdNamespaces.MERLIN_PROGRAM_ID,
	AlternateIdNamespaces.SKIP_PROGRAM_ID
];

export const AlternateIdsEditor: FC<AlternateIdsEditorProps> = (props) => {
	const { alternateIds, airingId, refetchAiringDetails } = props;
	const { setAlert } = useAlertContext() || [];
	const [createAlternateIdMethod] = useMutation<CreateOrUpdateAlternateIdResult, CreateOrUpdateAlternateIdVariables>(createAlternateId);
	const [deleteAlternateIdMethod] = useMutation<DeleteAlternateIdResult, DeleteAlternateIdVariables>(deleteAlternateId);

	const handleAlternateIdAdd = (newData: AlternateId): Promise<unknown> => {
		const id = NON_UNIQUE.includes(newData.namespace)
			? `${airingId}#${newData.namespace}:${newData.id.trim()}`
			: `airing#${newData.namespace}:${newData.id.trim()}`;

		const alternateIdInput = {
			namespace: newData.namespace,
			id,
			alternateId: `airing#${airingId}`
		} as AlternateIdInput;

		return createAlternateIdMethod({
			variables: { alternateId: alternateIdInput as AlternateIdInput }
		})
			.then(() => refetchAiringDetails())
			.catch((error) => {
				setAlert(error.toString());
			});
	};

	const handleAlternateIdDelete = (oldData: AlternateId): Promise<unknown> => {
		const { id } = oldData;

		return deleteAlternateIdMethod({
			variables: { id }
		})
			.then(() => refetchAiringDetails())
			.catch((error) => {
				setAlert(error.toString());
			});
	};

	return <AlternateIds alternateIds={alternateIds} onRowAdd={handleAlternateIdAdd} onRowDelete={handleAlternateIdDelete} />;
};

type AlternateIdsEditorProps = {
	alternateIds: AlternateId[];
	airingId: string;
	refetchAiringDetails: () => void;
};

export default AlternateIdsEditor;
